import { render } from "./ButtonPropsCmp.vue?vue&type=template&id=47f15813"
import script from "./ButtonPropsCmp.vue?vue&type=script&lang=js"
export * from "./ButtonPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__